import { DEFAULT_STATE } from '../constants'

export const initialThreeDPrintOnlyState = {
  withMakes: DEFAULT_STATE.withMakes,
  threeDPrintVerified: DEFAULT_STATE.threeDPrintVerified,
  multiColor: DEFAULT_STATE.multiColor,
}
